import React from 'react';
import './footer-style.css'

const Footer = () => {
    return (
        <div className="footer">
            <p>&copy; 2020 Airbnb colne! This is demo.</p>
            <p>React Person Asikur Rahaman</p>
        </div>
    );
};

export default Footer;